export default __webpack_public_path__ + "static/media/pfF.d9359ed5.png";